document.addEventListener('DOMContentLoaded', function () {
    const tabItems = document.querySelectorAll('.hv2-tabs .hv2-tabs__tab-item');

    if (tabItems.length > 0) {
        const screenshot = document.querySelector('.hv2-tabs .hv2-tabs__tab-content .screenshot');
        const screenshotimg = document.querySelector('.hv2-tabs .hv2-tabs__tab-content .screenshotimg');
        const screenshotwebp = document.querySelector('.hv2-tabs .hv2-tabs__tab-content .screenshotwebp');
        screenshot.src = tabItems[0].getAttribute('data-image');
        screenshotimg.srcset = tabItems[0].getAttribute('data-image');
        screenshotwebp.srcset = tabItems[0].getAttribute('data-imagewebp');
        screenshot.alt= tabItems[0].getAttribute('data-alt');
        screenshot.style.opacity = "1"
        screenshot.style.transform = "translateY(0)";
        const pattern = document.querySelector(".hv2-tabs .hv2-tabs__pattern");
        const patternSrc = tabItems[0].getAttribute('data-pattern');
        pattern.style.backgroundImage = `url(${patternSrc})`;
        pattern.style.opacity = "1";
        tabItems[0].classList.add('active');

        const tabHeadings = document.querySelectorAll('.hv2-tabs .hv2-tabs__tab-item-heading');
        tabHeadings.forEach(function (heading) {
            heading.addEventListener('click', function (event) {
                event.preventDefault();
                const tabItem = this.closest('.hv2-tabs__tab-item');
                tabItems.forEach(function (item) {
                    if (item !== tabItem) {
                        item.classList.remove('active');
                    }
                });
                tabItem.classList.toggle('active');
                const imageSrc = tabItem.getAttribute('data-image');
                const imageAlt = tabItem.getAttribute('data-alt');
                const imageSrcWebp = tabItem.getAttribute('data-imagewebp');
                const patternCurrentSrc = tabItem.getAttribute('data-pattern');
                screenshot.style.opacity = "0";
                screenshot.style.transform = "translateY(40px)";
                pattern.style.opacity = "0";
                setTimeout(function () {
                    screenshot.src = imageSrc;
                    screenshot.alt = imageAlt;
                    screenshotimg.srcset = imageSrc;
                    screenshotwebp.srcset = imageSrcWebp;
                    pattern.style.backgroundImage = `url(${patternCurrentSrc})`;
                    screenshot.style.opacity = "1";
                    screenshot.style.transform = "translateY(0)";
                    pattern.style.opacity = "1";
                }, 600);
            });
        });
    }
});